var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmotsmileSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#439400",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.415 18.974c-0.508-0.227-1.097 0.002-1.321 0.506-0.020 0.044-2.067 4.506-7.17 4.566-0.031 0-0.063 0.001-0.094 0.001-4.802 0-6.873-4.387-6.959-4.575-0.229-0.5-0.818-0.723-1.322-0.496-0.503 0.227-0.726 0.819-0.499 1.323 0.106 0.236 2.668 5.748 8.776 5.748 0.040 0 0.081-0.001 0.121-0.001 6.371-0.075 8.87-5.521 8.973-5.752 0.227-0.505-0.001-1.096-0.505-1.32zM16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 30c-7.72 0-14-6.28-14-14s6.28-14 14-14 14 6.28 14 14-6.28 14-14 14zM10.984 14.995c1.102 0 1.995-0.893 1.995-1.995s-0.893-1.995-1.995-1.995c-1.102 0-1.995 0.893-1.995 1.995s0.893 1.995 1.995 1.995zM20.984 14.995c1.102 0 1.995-0.893 1.995-1.995s-0.893-1.995-1.995-1.995c-1.102 0-1.995 0.893-1.995 1.995s0.892 1.995 1.995 1.995z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotsmileSvgrepoCom);
export default __webpack_public_path__ + "static/media/emotsmile-svgrepo-com.3144bb72cf049019e2021f107ad4a5fb.svg";
export { ForwardRef as ReactComponent };